import axios from '../../axios'

/*
 * 权限数据接口
 */

// 获取权限列表
export const getPermList = (data) => {
    return axios({
        url: '/api/admin/perm',
        method: 'get',
        data
    })
}

// 新增权限信息
export const savePerm = (data) => {
    return axios({
        url: '/api/admin/perm',
        method: 'post',
        data
    })
}

// 编辑权限信息
export const updatePerm = (data) => {
    return axios({
        url: '/api/admin/perm',
        method: 'put',
        data
    })
}

// 删除权限列表
export const deletePerm = (data) => {
    return axios({
        url: '/api/admin/perm',
        method: 'delete',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/perm.js